module.exports = "//static.hsappstatic.net/LoginUI/static-1.8304/img/chatspot-icon.png"